<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">{{ getUserDisplayName() }}</h1>
        <p class="user-mgmt-page__subtitle">{{ viewUser.email }}</p>
        <div class="user-mgmt-page__meta">
          <app-status-bubble [status]="viewUser.status"></app-status-bubble>
        </div>
      </div>
      <div class="user-mgmt-page__actions">
        @if (showeditbutton) {
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="button" (click)="navigate()">
            <mat-icon>edit</mat-icon>
            Edit User
          </button>
        }
        @if (showDeleteButton) {
          <button class="user-mgmt-page__btn user-mgmt-page__btn--danger" type="button" (click)="deleteUser()">
            <mat-icon>delete</mat-icon>
            Delete
          </button>
        }
      </div>
    </header>

    <section class="user-mgmt-page__card">
      <div class="user-mgmt-page__card-head">
        <h2>User Details</h2>
      </div>
      <div class="user-mgmt-page__card-body">
        <div class="user-mgmt-page__details-grid">
          @if (!viewUser.isParticipant) {
            <div class="user-mgmt-page__detail">
              <span class="user-mgmt-page__detail-label">First Name</span>
              <span class="user-mgmt-page__detail-value">{{ viewUser.firstName }}</span>
            </div>
          }
          @if (!viewUser.isParticipant) {
            <div class="user-mgmt-page__detail">
              <span class="user-mgmt-page__detail-label">Last Name</span>
              <span class="user-mgmt-page__detail-value">{{ viewUser.lastName }}</span>
            </div>
          }
          @if (viewUser.isParticipant) {
            <div class="user-mgmt-page__detail">
              <span class="user-mgmt-page__detail-label">Display Name</span>
              <span class="user-mgmt-page__detail-value">{{ viewUser.displayName }}</span>
            </div>
          }
          <div class="user-mgmt-page__detail">
            <span class="user-mgmt-page__detail-label">Email</span>
            <span class="user-mgmt-page__detail-value">{{ viewUser.email }}</span>
          </div>
          <div class="user-mgmt-page__detail">
            <span class="user-mgmt-page__detail-label">Account Creation Date</span>
            <span class="user-mgmt-page__detail-value">{{ viewUser.accountCreationDate }}</span>
          </div>
          <div class="user-mgmt-page__detail">
            <span class="user-mgmt-page__detail-label">Last Active</span>
            <span class="user-mgmt-page__detail-value">{{ viewUser.lastActiveDate || '—' }}</span>
          </div>
          <div class="user-mgmt-page__detail">
            <span class="user-mgmt-page__detail-label">Province</span>
            <span class="user-mgmt-page__detail-value">{{ viewUser.province || '—' }}</span>
          </div>
          @if (viewUser.isBranchVisible) {
            <div class="user-mgmt-page__detail">
              <span class="user-mgmt-page__detail-label">Branch</span>
              <span class="user-mgmt-page__detail-value">{{ viewUser.branch || '—' }}</span>
            </div>
          }
          @if (viewUser.isOrganizationVisible) {
            <div class="user-mgmt-page__detail">
              <span class="user-mgmt-page__detail-label">Organization</span>
              <span class="user-mgmt-page__detail-value">{{ viewUser.organization || '—' }}</span>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="user-mgmt-page__card">
      <div class="user-mgmt-page__card-head">
        <h2>Roles</h2>
      </div>
      <div class="user-mgmt-page__card-body">
        @if (viewUser.roles.length === 0) {
          <span class="user-mgmt-page__empty-text">No roles currently assigned to the user.</span>
        }
        @if (viewUser.roles.length > 0) {
          <table mat-table class="fileList primary" [dataSource]="viewUser.roles">
            <ng-container matColumnDef="roleName">
              <th mat-header-cell *matHeaderCellDef>Role</th>
              <td mat-cell *matCellDef="let item">{{ item.roleName }}</td>
            </ng-container>
            <ng-container matColumnDef="roleAssigned">
              <th mat-header-cell *matHeaderCellDef>Role Assigned</th>
              <td mat-cell *matCellDef="let item">{{ item.roleAssigned }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="roleColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: roleColumns"></tr>
          </table>
        }
      </div>
    </section>

    @if (viewUser.isParticipant) {
      <section class="user-mgmt-page__card">
        <div class="user-mgmt-page__card-head">
          <h2>Programs</h2>
        </div>
        <div class="user-mgmt-page__card-body">
          @if (!viewUser.participantPrograms?.length) {
            <span class="user-mgmt-page__empty-text">No programs found.</span>
          }
          @if (viewUser.participantPrograms?.length) {
            <ul class="user-mgmt-page__chip-list">
              @for (item of viewUser.participantPrograms; track item) {
                <li>
                  <span class="user-mgmt-page__chip user-mgmt-page__chip--program">{{ item.programName }}</span>
                </li>
              }
            </ul>
          }
        </div>
      </section>
    }

    @if (viewUser.isSpecialPermissionVisible) {
      <section class="user-mgmt-page__card">
        <div class="user-mgmt-page__card-head">
          <h2>Special Permissions</h2>
        </div>
        <div class="user-mgmt-page__card-body">
          <p class="user-mgmt-page__subtitle">Participant has been granted access to the following additional courses/sessions.</p>
          @if (!viewUser.participantSpecialPermissions?.length) {
            <span class="user-mgmt-page__empty-text">No special permissions found.</span>
          }
          @if (viewUser.participantSpecialPermissions?.length) {
            <table mat-table class="fileList primary w-100" [dataSource]="viewUser.participantSpecialPermissions || []">
              <ng-container matColumnDef="id"><th mat-header-cell *matHeaderCellDef>ID</th><td mat-cell *matCellDef="let item">{{ item.id }}</td></ng-container>
              <ng-container matColumnDef="courseName"><th mat-header-cell *matHeaderCellDef>Course/Session</th><td mat-cell *matCellDef="let item">{{ item.courseName }}</td></ng-container>
              <ng-container matColumnDef="programs"><th mat-header-cell *matHeaderCellDef>Program</th><td mat-cell *matCellDef="let item"><ul class="user-mgmt-page__chip-list">@for (program of item.programs; track program) {
              <li><span class="user-mgmt-page__chip user-mgmt-page__chip--program">{{ program }}</span></li>
            }</ul></td></ng-container>
            <ng-container matColumnDef="accessGranted"><th mat-header-cell *matHeaderCellDef>Access Granted</th><td mat-cell *matCellDef="let item">{{ item.accessGranted }}</td></ng-container>
            <ng-container matColumnDef="grantedBy"><th mat-header-cell *matHeaderCellDef>Granted By</th><td mat-cell *matCellDef="let item">{{ item.grantedBy }}</td></ng-container>
            <tr mat-header-row *matHeaderRowDef="specialPermissionColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: specialPermissionColumns"></tr>
          </table>
        }
      </div>
    </section>
  }

  @if (viewUser.isRecomendedCoursesVisible) {
    <section class="user-mgmt-page__card">
      <div class="user-mgmt-page__card-head">
        <h2>Recommended Courses/Sessions</h2>
      </div>
      <div class="user-mgmt-page__card-body">
        <p class="user-mgmt-page__subtitle">Courses that display on this user's dashboard.</p>
        @if (!viewUser.participantRecommendedCourses?.length) {
          <span class="user-mgmt-page__empty-text">No recommended courses found.</span>
        }
        @if (viewUser.participantRecommendedCourses?.length) {
          <table mat-table class="fileList primary w-100" [dataSource]="viewUser.participantRecommendedCourses || []">
            <ng-container matColumnDef="id"><th mat-header-cell *matHeaderCellDef>ID</th><td mat-cell *matCellDef="let item">{{ item.id }}</td></ng-container>
            <ng-container matColumnDef="courseName"><th mat-header-cell *matHeaderCellDef>Course/Session</th><td mat-cell *matCellDef="let item">{{ item.courseName }}</td></ng-container>
            <ng-container matColumnDef="programs"><th mat-header-cell *matHeaderCellDef>Program</th><td mat-cell *matCellDef="let item"><ul class="user-mgmt-page__chip-list">@for (program of item.programs; track program) {
            <li><span class="user-mgmt-page__chip user-mgmt-page__chip--program">{{ program }}</span></li>
          }</ul></td></ng-container>
          <ng-container matColumnDef="dateAssigned"><th mat-header-cell *matHeaderCellDef>Date Assigned</th><td mat-cell *matCellDef="let item">{{ item.dateAssigned }}</td></ng-container>
          <tr mat-header-row *matHeaderRowDef="recommendedCourseColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: recommendedCourseColumns"></tr>
        </table>
      }
    </div>
  </section>
}

<app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
</div>
</div>

<app-footer></app-footer>

@if (modalOpen | async) {
  <app-modal
    [title]="modalTitle"
    [content]="modalContent"
    [okButtonValue]="modalOkButtonValue"
    [cancelButtonValue]="modalCancelButtonValue"
    [okButtonText]="modalOkButtonText"
    [cancelButtonText]="modalCancelButtonText">
  </app-modal>
}
